<template>
  <div>
    <div v-if="datasetDetail">
      <DatasetDetail :dataset="datasetDetail" />
    </div>
    <div v-else>
      <DatasetList />
    </div>
  </div>
</template>

<script>
import DatasetList from "@/components/datasets/list.vue";
import DatasetDetail from "@/components/datasets/detail.vue";
import { getDatesetFromHash } from "@/lib/helpers";

export default {
  components: {
    DatasetList,
    DatasetDetail
  },
  data: function() {
    return {
      datasetDetail: null
    };
  },
  mounted() {
    if (this.$route.hash) {
      this.datasetDetail = getDatesetFromHash(this.$route.hash);
    }
  },
  watch: {
    "$route.hash"() {
      this.datasetDetail = getDatesetFromHash(this.$route.hash);
    }
  }
};
</script>
